import { PortableTextBlock } from '@portabletext/react';
import clsx from 'clsx';
import { GatsbyImage } from 'gatsby-plugin-image';
import { twMerge } from 'tailwind-merge';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { H2 } from 'components/rebrand/Typography';

import { ISanityImage } from 'typescriptDefs';

type Props = {
  className?: string;
  description?: string | PortableTextBlock | PortableTextBlock[];
  heading: string | PortableTextBlock | PortableTextBlock[];
  testimonialList: { img: ISanityImage | null; altText: string | null }[];
  disableScroll?: boolean;
  scrollerClassName?: string;
};

const TestimonialImages = ({ index, testimonials }: { index: number; testimonials: Props['testimonialList'] }) => {
  return (
    <>
      {testimonials.map(({ img, altText }, i) =>
        img ? (
          <div
            key={`${index}-${altText}-${i}`}
            className={twMerge(clsx('mr-16 h-full w-320 md:mr-32 md:w-432', i % 2 === 0 && 'w-240 md:w-324'))}
          >
            <GatsbyImage className="h-full w-full rounded-12" image={img.asset.gatsbyImageData} alt={altText ?? ''} />
          </div>
        ) : null,
      )}
    </>
  );
};

const TestimonialsScrolling = ({
  className,
  description,
  heading,
  testimonialList,
  disableScroll = false,
  scrollerClassName,
}: Props) => {
  return (
    <Section className={twMerge('py-64 md:py-96', className)}>
      <Container className="mb-64 px-32 text-center xs:px-0 [&>*]:mx-auto md:[&>p]:w-[45%] [&_.small]:mt-16 [&_p]:text-lg [&_p]:md:text-xl">
        {typeof heading === 'string' ? (
          <H2 className={twMerge(clsx('pb-16 text-primary-400 md:w-[65%] md:pb-24', !description && 'pb-0 md:pb-0'))}>
            {heading}
          </H2>
        ) : (
          <div className={twMerge(clsx('pb-16 text-primary-400 md:w-[65%] md:pb-24', !description && 'pb-0 md:pb-0'))}>
            <CustomPortableText content={heading} />
          </div>
        )}
        {description ? (
          typeof description === 'string' ? (
            <p className="text-md font-normal leading-normal md:text-lg">{description}</p>
          ) : (
            <CustomPortableText content={description} />
          )
        ) : null}
      </Container>

      <div
        className={twMerge(
          clsx('w-auto whitespace-nowrap md:overflow-hidden', disableScroll ? 'overflow-hidden' : 'overflow-scroll'),
        )}
      >
        <div
          className={twMerge(
            'flex h-320 w-fit animate-slideShowMobile md:h-432 md:animate-slideShowDesktop',
            scrollerClassName,
          )}
        >
          <TestimonialImages index={0} testimonials={testimonialList} />
          <TestimonialImages index={1} testimonials={testimonialList} />
          <TestimonialImages index={2} testimonials={testimonialList} />
          <TestimonialImages index={3} testimonials={testimonialList} />
        </div>
      </div>
    </Section>
  );
};

export default TestimonialsScrolling;
